'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import 'select2';
import { tr, lang } from '../../utils/helpers';
import { companyUnity, selectChannel } from '../../modules/select';

const registerShowRegistrationForm = {
  settings: {
    $selectChannel: $('.js-select-channel'),
    $selectCompany: $('.js-companies'),
    $selectUnity: $('.js-unities'),
    $inputEmail: $('.js-form-email'),
  },

  init() {
    var error = true;

    selectChannel();
    companyUnity();

    $('.js-step-nav').on('click', function (e) {
      e.preventDefault();

      const target = $(this).attr('href');
      const targetStep = $(this).attr('data-target');
      const currentStep = $('.tab.active').attr('data-step');

      if (targetStep > currentStep) {
        const errorMessage = validateStep(currentStep);

        if (errorMessage) {
          Swal.fire(tr[lang].modal_error_attention, errorMessage, 'error');
          return false;
        }
      }

      $('.tab').removeClass('active');
      $('.steps-link').removeClass('active');
      $(target).addClass('active');
      $(`.steps-link[data-target="${targetStep}"]`).addClass('active');
    });

    function validateStep(step) {
      switch (step) {
        case '1':
          if (lang === 'pt-BR') {
            if ($("input[name='cpf']").val().length < 14) {
              return tr[lang].modal_error_fields;
            }
          } else {
            if ($("input[name='cpf']").val().length < 6) {
              return tr[lang].modal_error_fields;
            }
          }

          if ($("input[name='cpf']").hasClass('is-invalid') || $("input[name='name']").val() == '') {
            return tr[lang].modal_error_fields;
          }
          break;
        case '2':
          if (
            s.$inputEmail.val() === '' ||
            $("input[name='email']").hasClass('is-invalid') ||
            $("input[name='mobile_phone']").val() === '' ||
            s.$selectChannel.val() === '' ||
            ($("input[name='channel_other']").is(':visible') && $("input[name='channel_other']").val() === '')
          ) {
            return tr[lang].modal_error_fields;
          }
          break;
        case '3':
          if (s.$selectCompany.val() === '' || s.$selectUnity.val() === '' || s.$selectUnity.val() === '0') {
            return tr[lang].modal_error_fields;
          }
          break;
      }
      return null;
    }

    $(document).on('change', 'input[name="company"]', function () {
      if ($("input[name='company']:checked").val() === 'participations') {
        $('#company_participacoes_terms').removeClass('u-display--none');
        $('#company_logistica_terms').addClass('u-display--none');
      } else {
        $('#company_participacoes_terms').addClass('u-display--none');
        $('#company_logistica_terms').removeClass('u-display--none');
      }
      document.getElementById('btn-register').disabled = true;
    });

    $('.js-form-cpf').on('change keyup paste', function (e) {
      e.preventDefault();

      var cpf = $(this).val();
      if (cpf != '') {
        var validacpf = /^[0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2}$/;

        if (validacpf.test(cpf)) {
          getCpf(cpf);
        } else {
          $('#cpf').removeClass('is-invalid');
          $('#cpf-error').text('');
        }
      }
    });

    function getCpf(cpf) {
      var url = '/check-cpf/' + cpf;

      $.ajax({
        type: 'get',
        url: url,
        dataType: 'json',
        data: {},
        success: function (response) {
          if (!response.success) {
            $('#cpf').addClass('is-invalid');
            $('#cpf-error').text(response.message);
          }
        },
        error: function (jqXHR, status, error) {
          console.log(error);
        },
      });
    }

    const emailDV = localStorage.getItem('emailDV');
    if (s.$inputEmail.val().trim() === '' && emailDV !== null && emailDV !== '') {
      s.$inputEmail.val(emailDV);
      getEmail(emailDV);
    }

    s.$inputEmail.on('change keyup paste', function (e) {
      e.preventDefault();

      var email = $(this).val();
      if (email != '') {
        getEmail(email);
      }
    });

    function getEmail(email) {
      var url = '/check-email/' + email;

      $.ajax({
        type: 'get',
        url: url,
        dataType: 'json',
        data: {},
        success: function (response) {
          if (!response.success) {
            $('#email').addClass('is-invalid');
            $('#email-error').text(response.message);
            error = true;
          } else {
            $('#email').removeClass('is-invalid');
            $('#email-error').text('');
            error = false;
          }
        },
        error: function (jqXHR, status, error) {},
      });
    }

    $('.js-form-enrollment').on('input', function (e) {
      e.preventDefault();
      var enrollment = $(this).val();
      if (enrollment != '') {
        getEnrollment(enrollment);
      }
    });

    function getEnrollment(enrollment) {
      var url = '/check-enrollment/' + enrollment;
      $.ajax({
        type: 'get',
        url: url,
        dataType: 'json',
        data: {},
        success: function (response) {
          if (!response.success) {
            $('#enrollment').addClass('is-invalid');
            $('#enrollment-error').text(response.message);
            error = true;
          } else {
            $('#enrollment').removeClass('is-invalid');
            $('#enrollment-error').text('');
            error = false;
          }
        },
        error: function (jqXHR, status, error) {},
      });
    }

    function validatePassword(password) {
      // Check for at least one digit
      var hasDigit = /\d/.test(password);

      // Check for at least one uppercase letter
      var hasUpperCase = /[A-Z]/.test(password);

      // Check for at least one lowercase letter
      var hasLowerCase = /[a-z]/.test(password);

      // Check for at least one special character
      var hasSpecialChar = /[@$!%*?&]/.test(password);

      // Check if all conditions are met
      return hasDigit && hasUpperCase && hasLowerCase && hasSpecialChar && password.length >= 8;
    }

    $('#form-signin').on('submit', function (e) {
      e.preventDefault();
      const captcha = grecaptcha.getResponse();
      const checkLength = $('.js-check').length;

      if (!validatePassword($("input[name='password']").val())) {
        Swal.fire('Formato de senha inválido!', '', 'error');
        return false;
      }

      if (captcha.length !== 0 && $('.js-check:checked').length === checkLength) {
        localStorage.removeItem('emailDV');
        e.target.submit();
      } else {
        if ($('.js-check:checked').length !== checkLength) {
          Swal.fire(tr[lang].modal_error_terms, '', 'error');
        } else {
          Swal.fire(tr[lang].modal_error_captcha, '', 'error');
        }
      }
    });
  },
};

const s = registerShowRegistrationForm.settings;

export default registerShowRegistrationForm;
